import React from 'react';
import './billing.css';

// Used of included this month, plus any add-on credits
const UsageMeter = ({ label, used, limit, credits = 0, compact, neutral }) => {
    const percent = limit > 0 ? Math.min(100, (used / limit) * 100) : 0;
    // Counts (like products) aren't a budget running out, so they don't turn amber or red
    const state = neutral ? 'is-neutral' : limit > 0 && used >= limit && credits === 0 ? 'is-full' : percent >= 80 ? 'is-high' : '';
    return (
        <div className={`ls-meter ${state}${compact ? ' is-compact' : ''}`}>
            <div className="ls-meter-head">
                <span>{label}</span>
                <span className="ls-meter-count">
                    {limit === 0 && credits === 0 ? <span className="ls-muted" style={{ fontWeight: 500 }}>Not on this plan</span> : `${used} / ${limit}`}
                    {credits > 0 && <span className="ls-muted"> + {credits} extra</span>}
                </span>
            </div>
            <div className="ls-meter-track"><div style={{ width: `${percent}%` }} /></div>
        </div>
    );
};

export default UsageMeter;
